import _ from 'lodash';
import * as types from '../mutation-types';
import brokers from '../../api/brokers';
import users from '@/api/user';
import businesses from '@/api/businesses';

const state = {
  brokers: [],
  selected: {
    id: null,
    logo: null,
    campaigns: {}
  },
  search: ''
};

const getters = {
  BrokersList: state => state.brokers,
  BrokerSearch: state => state.search,
  SelectedBroker: state => state.selected
};

const actions = {
  getBrokersList({ commit, dispatch }) {
    brokers.getBrokersList().then(response => {
      commit(types.SET_BROKERS_LIST, response.data);
      if (response.data.length > 0) {
        dispatch('selectBroker', response.data[0].id);
      }
    });
  },
  selectBroker({ commit }, id) {
    brokers.getBroker(id).then(response => commit(types.SELECT_BROKER, response.data));
  },
  registerBroker({ dispatch }, broker) {
    return new Promise((resolve, reject) => {
      brokers
        .register(broker)
        .then(() => {
          dispatch('getBrokersList');
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  updateSelectedBroker({ commit, dispatch }, updates) {
    const brokerId = state.selected.id;
    return new Promise((resolve, reject) => {
      businesses
        .update(brokerId, updates)
        .then(broker => {
          if (state.selected.parent_id !== broker.data.parent_id) {
            dispatch('getBrokersList');
          } else {
            dispatch('selectBroker', brokerId);
            commit(types.SET_SELECTED_BROKER_IN_LIST, broker.data);
          }
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  updateBrokerUser({ dispatch, state }, { id, updates }) {
    const brokerId = state.selected.id;
    return new Promise((resolve, reject) => {
      users
        .updateUser(id, updates)
        .then(() => {
          dispatch('selectBroker', brokerId);
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  sendBrokerWelcomeMessage({ dispatch, state }, id) {
    const brokerId = state.selected.id;
    return new Promise((resolve, reject) => {
      users
        .sendWelcomeMessage(id)
        .then(() => {
          dispatch('selectBroker', brokerId);
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  setBrokerSearch({ commit }, search) {
    commit(types.SET_BROKER_SEARCH, search);
  }
};

const mutations = {
  [types.SET_BROKERS_LIST](state, brokers) {
    state.brokers = brokers;
  },
  [types.SET_SELECTED_BROKER_IN_LIST](state, response) {
    let id = response.id;
    let parentId = response.parent_id;
    if (_.isNull(parentId)) {
      let index = _.findIndex(state.brokers, { id });
      _.merge(state.brokers[index], response);
    } else {
      let index = _.findIndex(state.brokers, { id: parentId });
      let subIndex = _.findIndex(state.brokers[index]['children'], { id });
      _.merge(state.brokers[index]['children'][subIndex], response);
    }
  },
  [types.SELECT_BROKER](state, broker) {
    state.selected = broker;
  },
  [types.SET_BROKER_SEARCH](state, search) {
    state.search = search;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
